import React from "react";
import MaterialDrawer from "@material-ui/core/Drawer";
import CloseIcon from "@material-ui/icons/Close";
import classNames from "classnames";
import Title from "../title/title";
import Text from "../text/text";
import styles from "./side-drawer.module.scss";

const SideDrawer = ({
  active,
  close,
  title,
  subtitle,
  children,
  footer,
  closable = true,
  closeOnDimmer = true,
  width = 480,
  className,
  contentClassName,
}) => {
  return (
    <MaterialDrawer
      anchor="right"
      open={Boolean(active)}
      onClose={closeOnDimmer && closable ? close : null}
      className={styles.root}
      PaperProps={{ className: classNames(styles.paper, className), style: { width } }}
    >
      <div className={styles.header}>
        <div className={styles.headerText}>
          {title && (
            <Title small black className={styles.title}>
              {title}
            </Title>
          )}
          {subtitle && <Text subtitle>{subtitle}</Text>}
        </div>
        {closable && (
          <div className={styles.close} onClick={() => close()}>
            <CloseIcon className={styles.icon} />
          </div>
        )}
      </div>
      <div className={classNames(styles.content, contentClassName)}>{children}</div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </MaterialDrawer>
  );
};

export default SideDrawer;
